import { Model, Schema } from "src/engine/modules/model/classes"
import { denormalizeEvent } from "src/models/event"
import memoize from "lodash/memoize"

const entityName = `planEvents`

export default memoize(
  planId =>
    new Model({
      name: entityName,
      getRestUrn: () => `/plans/${planId}/events`,
      primaryKey: `uuid`,
      denormalize: denormalizeEvent,
      schema: new Schema({
        startDateTime: new Schema.types.DateTime(`ms`),
        endDateTime: new Schema.types.DateTime(`ms`),
      }),
    }),
)
